import RootTooltip from '@/components/Tooltip';

export const Tooltip = ({ tip, label }: { tip: string; label: string }) => {
  return (
    <RootTooltip
      title={
        <div className="max-w-[260px]">
          <p className="m-0 text-left text-tiny text-legacy-spacegray">{tip}</p>
        </div>
      }
      light
      placement="top"
      zIndex={99999}
    >
      <span className="m-0 border-0 border-b-2 border-dotted border-strong text-tiny text-soft">
        {label}
      </span>
    </RootTooltip>
  );
};
